import { useEffect, useMemo, useState } from 'react'
import { Box, Flex, Spacer } from '@chakra-ui/react'
import { useRecoilState } from 'recoil'

import { FormAuthType } from '~shared/types/form/form'

import { usePublicFormContext } from '~features/public-form/PublicFormContext'

import { DraftSubmissionId } from '../../../../../atom'
import { FormAuth } from '../FormAuth'

import { FormFields } from './FormFields'
import { FormFieldsSkeleton } from './FormFieldsSkeleton'
import { FormSectionsProvider } from './FormSectionsContext'
import { SectionSidebar } from './SectionSidebar'

export const FormFieldsContainer = (preview: any): JSX.Element | null => {
  const { form, isAuthRequired, isLoading, handleSubmitForm, submissionData } =
    usePublicFormContext()
  const [paymentAmount, setPaymentAmount] = useState<number>(0)
  const [draftId, setDraftId] = useRecoilState(DraftSubmissionId)
  useEffect(
    () => () => {
      setDraftId(null)
    },
    [],
  )

  useEffect(() => {
    let paymentAmounts = 0
    form?.paymentCharges?.map((data) => {
      paymentAmounts = paymentAmounts + data.amount
    })
    setPaymentAmount(paymentAmounts)
  }, [form])

  const renderFields = useMemo(() => {
    // Render skeleton when no data
    if (isLoading) {
      return <FormFieldsSkeleton />
    }

    if (!form) {
      // TODO: Add/redirect to error page
      return <div>Something went wrong</div>
    }
    if (preview && preview.preview) {
      //
    } else {
      // Redundant conditional for type narrowing
      if (isAuthRequired && form.authType !== FormAuthType.NIL) {
        return <FormAuth authType={form.authType} />
      }
    }

    if (preview && preview.preview) {
      return (
        <FormFields
          formFields={form.form_fields}
          formLogics={form.form_logics}
          formAuthType={form.authType}
          colorTheme={form.startPage.colorTheme}
          paymentRequired={false}
          paymentAmount={paymentAmount}
          paymentCharges={form.paymentCharges}
          onSubmit={handleSubmitForm}
          preview={true}
        />
      )
    } else {
      return (
        <FormFields
          formFields={form.form_fields}
          formLogics={form.form_logics}
          formAuthType={form.authType}
          colorTheme={form.startPage.colorTheme}
          paymentRequired={form.paymentRequired}
          paymentAmount={paymentAmount}
          paymentCharges={form.paymentCharges}
          onSubmit={handleSubmitForm}
          preview={false}
          signatureRequired={form.signatureRequired}
          signatureTypes={form.signatureTypes}
        />
      )
    }
  }, [form, handleSubmitForm, isAuthRequired, paymentAmount, isLoading])

  if (submissionData) return null

  return (
    <FormSectionsProvider form={form}>
      <Flex justify="center">
        {isAuthRequired ? null : <SectionSidebar />}
        <Box w="100%" minW={0} h="fit-content" maxW="57rem">
          {renderFields}
        </Box>
        {isAuthRequired ? null : <Spacer />}
      </Flex>
    </FormSectionsProvider>
  )
}
